<script setup>
import { ref, inject } from 'vue';
import { useOrganizationStore } from '@/stores/organization';
import { storeToRefs } from 'pinia';

const { search } = useOrganizationStore();
const { all } = storeToRefs(useOrganizationStore());

const params = ref({
    term: '',
    status: null,
    page: 1,
    sort_by: null,
    per_page: 10,
});

const searchOrganization = () => {
    search({
        ...params.value,
    });
};

const modals = inject('modals');

const clearSearch = () => {
    params.value.term = '';
    searchOrganization();
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    searchOrganization();
};

const openModal = (modal, mode = 'Create', organization = null) => {
    modals.show(modal, {
        props: organization ? {
            organization: organization,
            mode: mode
        } : {
            mode: mode,
        }
    }).then(() => {
        searchOrganization();
    });
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.organization_management') }}</template>
    <template #actions>
        <StyledButton @click="openModal('OrganizationsModal')"><FontAwesomeIcon icon="plus" class="mr-1" />
            {{  $t('label.new_organization') }}
        </StyledButton>
    </template>
    <div class="grid lg:grid-cols-3 md:gap-4 md:mb-4">
        <StyledSearch
            v-model="params.term"
            v-debounce:500ms="searchOrganization"
            name="search"
            :label="$t('label.search')"
            :debounce-events="['input']"
            @click:clear="clearSearch" />
        <StyledDropdown
            v-model="params.status"
            clearable
            :placeholder="$t('label.status')"
            :options="[
                { label: $t('label.active'), value: true },
                { label: $t('label.inactive'), value: false },
            ]"
            name="status"
            @input="searchOrganization"
            @click:clear="searchOrganization" />
    </div>
    <DataTable
        v-if="all"
        :data="all"
        :headers="[
            { title: $t('label.logo'), key: 'logo', sortable: false },
            { title: $t('label.name'), key: 'name', value: item => item.name, sortable: false },
            { title: $t('label.associated_profiles'), key: 'profiles_count', value: item => item.profiles_count, sortable: false },
            { title: $t('label.status'), key: 'status', value: item => item.is_active ? $t('label.active') : $t('label.inactive'), sortable: false },
        ]"
        :actions="[
            { title: 'Edit', icon: 'edit', action: (item) => openModal('OrganizationsModal', 'Edit', item) },
        ]"
        @table-update="tableUpdate">
        <template #item.logo="{ item }">
            <img v-if="item.logo_url" :src="item.logo_url" class="w-10 h-10 object-contain rounded border">
        </template>
    </DataTable>
</MainContentLayout>
</template>
